import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, NgModule, OnInit } from '@angular/core';
import { ActionLinkModule } from '@app/components/actions/action-link/action-link.component';
import { ErrorTemplatesModule } from '@app/components/error-templates/error-templates.component';
import { TextPlaceholderModule } from '@app/components/text-placeholder/text-placeholder.component';
import { WidgetPlaceholderModule } from '@app/components/widget-placeholder/widget-placeholder.component';
import { PersonExtended } from '@app/models/person-extended';
import { LinkModule } from '@app/directives/link.directive';
import { UserService } from '@app/services/user.service';
import { User } from '@microsoft/microsoft-graph-types';
import { combineLatest, Observable, of, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ActionRouterLinkModule } from '../actions/action-router-link/action-router-link.component';
import { PeopleCardModule } from '../people-card/people-card.component';

@Component({
  selector: 'app-colleagues',
  templateUrl: './colleagues.component.html',
  styleUrls: ['./colleagues.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ColleaguesComponent implements OnInit {

  myColleagues$: Observable<Array<PersonExtended>>;
  @Input() myColleaguesCount = 7;
  allColleagues: string;
  loggedInUserProfileProp: string;
  me$: Observable<User>;
  private errorSubject$ = new Subject();
  componentName = 'Find your colleagues';

  constructor(private userService: UserService) { }

  ngOnInit() {

    this.me$ = this.userService.getMyDetailsFromMsGraph();

    this.myColleagues$ = combineLatest([
      this.userService.getRelatedPeople(this.myColleaguesCount),
      this.me$])
      .pipe(map(([colleagues, user]) => {
        const myColeagues = colleagues
          .filter(item => item.id !== user.id)
          .map(colleague => {
            return PersonExtended.fromPerson(colleague);
          });
        // Show maximum of 6 colleague cards only.
        if (myColeagues.length === this.myColleaguesCount) {
          return myColeagues.slice(0, this.myColleaguesCount - 1);
        } else {
          return myColeagues;
        }
      }),
        catchError(err => {
          this.errorSubject$.next(err);
          return of(null);
        }));
  }

  getUrl(user: User) {
    return 'https://delve.office.com/?u=' + user.id + '&v=liveprofileworkingwith';
  }
}

@NgModule({
  declarations: [ColleaguesComponent],
  exports: [ColleaguesComponent],
  imports: [
    CommonModule,
    ActionLinkModule,
    TextPlaceholderModule,
    WidgetPlaceholderModule,
    ErrorTemplatesModule,
    LinkModule,
    ActionRouterLinkModule,
    PeopleCardModule,
  ],
})
export class ColleaguesModule { }
